import type { FormElement } from '../model/form.types';
import { iterateFormElements } from './form-element-traversal';

export interface DuplicateFieldId {
  name: string;
  elements: { id: string; label: string }[];
}

export function findDuplicateFieldIds(
  elements: ReadonlyArray<FormElement>,
): DuplicateFieldId[] {
  const byName = new Map<string, FormElement[]>();
  for (const el of iterateFormElements(elements, { includeTableContainers: true })) {
    const name = el.properties.name?.trim();
    if (!name) continue;
    const group = byName.get(name) ?? [];
    group.push(el);
    byName.set(name, group);
  }
  return [...byName.entries()]
    .filter(([, els]) => els.length > 1)
    .map(([name, els]) => ({
      name,
      elements: els.map((e) => ({
        id: e.id,
        label: e.properties.label?.trim() || e.properties.name,
      })),
    }));
}
